"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unprintableChars = exports.commaOrSpaceOrQuote = exports.alphanumericalNameWithDashAndDot = void 0;
exports.alphanumericalNameWithDashAndDot = /^[a-zA-Z0-9-_ .]+$/;
exports.commaOrSpaceOrQuote = /[\s,"]/;
exports.unprintableChars = /[^ -~]+/g;
